import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { Pipeline, ListProduct, TemplatePipelineProps, IPipeline } from "../../../interfaces/Pipeline";
import { TableColumn } from "react-data-table-component";
import { customNumberFormat, getDateSummary, isColorDarkFromHex, sortColumnDatatable, handleCaps, currencyFormatter, getCurrencySymbol, customThousandSeparatorDot } from "../../../functions/general";
import { useNavigate, useParams } from "react-router-dom";
import { UpdatePipeline } from "../../../components/Pipelines/UpdatePipeline";
import { DeletePipeline } from "../../../components/Pipelines/DeletePipeline";
import { AddPipeline } from "../../../components/Pipelines/BtnActionAddPipelineDropdown/AddPipeline";
import axios from "axios";
import useAccessToken from "../../../hooks/AccessToken";
import useSWR, { mutate } from "swr";
import { AddLog } from "../../../components/Pipelines/Logs/AddLog"
import { DateRangePicker } from 'rsuite';
import moment from "moment";
import useUser from "../../../hooks/User";
import { UserScopeModal, defaultScope } from "../../../components/DataTable/UserScopeModal";
import { UserScope } from "../../../interfaces/UserScope";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { CustomField } from "../../../interfaces/Settings";
import { FilterPipeline } from "../../../components/Pipelines/FilterPipeline";
import { KTSVG, toAbsoluteUrl } from "../../../_metronic/helpers";
import { checkWhatsapp, updateWhatsapp } from "../../../api/Whatsapp";
import Swal from "sweetalert2";
import Select from 'react-select'
import { DetailProductPipeline } from "../../../components/Pipelines/DetailProductPipeline";
import { AbandonedPipeline } from "../../../components/Pipelines/AbandonedPipeline";
import { useIntl } from "react-intl";
import usePredefinedRanges from "../../../hooks/PredefinedRanges";
import useCalendarLocale from "../../../hooks/CalendarLocale";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { Progress } from "../../../interfaces/Progress";
import { DataTableImport } from "../../../components/DataTable/DataTableImport";
import { DetailPipeline } from "../../../components/Pipelines/DetailPipeline";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { ActivityPipeline } from "../../../components/Pipelines/ActivityPipeline";
import useSearch from "../../../hooks/Search";
import { ExpandableElement } from "../../../components/General/ExpandableElement";
import { isActionActivitiyPipeline, isActionAddLogPipeline, isActionDeletePipeline, isActionDetailProductPipeline, isActionDetailTerminPipeline, isActionLogPipeline, isActionUpdatePipeline } from "../../../functions/customCase";
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { useTemplatePipeline } from "../../../stores/TemplatePipeline";
import DetailTerminPipeline from "../../../components/Pipelines/DetailTermin/DetailTerminPipeline";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { useDNDPipelineStore } from "../../../stores/DNDPipelineStore";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useModalEffect from "../../../hooks/useModalEffect";
import { getUserByToken } from "../../modules/auth/redux/AuthCRUD";
import OTPModal from "../../../components/Pipelines/Logs/OtpModal";
import { useRouteStore } from "../../../stores/RouteStore";
import { useVirtualizer } from "@tanstack/react-virtual";
import useCheckIsMobile from "../../../hooks/useCheckIsMobile";
import { VirtualizedSelectOption, VirtualizedSelectOptionsType } from "../../../components/Select/SelectVirtualized";
import BadgeTooltip from "../../../components/General/BadgeTooltip";
import useDragAndDropColumn from "../../../hooks/useDragAndDropColumn";
import useDragAndDropTemplate from "../../../hooks/useDragAndDropTemplate";
import { SHOW_COLUMN_MR_CODE } from "../../../constant/General";
import { MasterKanban } from "../../../components/Kanban/MasterKanban";
import { getEndDate, getStartDate, getTypeDate } from "../../../functions/pipeline";
import BtnActionDropdownPipeline from "../../../components/Pipelines/BtnActionAddPipelineDropdown/BtnActionDropdownPipeline";
import { useGeneralStore } from "../../../stores/General";
import useClearModalBackdropElement from "../../../hooks/useClearModalBackdropElement";
import { ModalAttachmentCustomField } from "../../../components/ModalGeneral/ModalAttachmentCustomField";
import { Label } from "../../../interfaces/Label";
import ComponentLabelsPipeline from "./ComponentLabelsPipeline";
import BtnActionDropdownExportExcelPipeline from "../../../components/Pipelines/BtnActionDropdownExportExcelPipeline";

interface UserData {
    id: string;
    name: string;
    username: string;
    phone: string;
}

export interface PipelineVirtualizedSelectOption extends VirtualizedSelectOption {
    nameCustomField?: string;
    nameTemplate?: string
    nameMerchant?: string
}

export interface PipelineVirtualizedSelectOptionsType extends VirtualizedSelectOptionsType {
    nameCustomField?: string;
    nameTemplate?: string
    nameMerchant?: string
}

interface MasterPipelinesContentProps {
    merchantId?: string
}

const API_URL = process.env.REACT_APP_API_URL

const MasterPipelinesContent: FC<MasterPipelinesContentProps> = ({ merchantId }) => {
    const { prevRoute } = useRouteStore()
    const user = useUser()
    const { templatePipelineId, templateMerchantId } = useParams()
    const { companyId, roleId, keyCustomfield } = useCustomeStore()
    const { multiPipelines, selectMultiPipeline, setSelectMultiPipeline } = usePipelineStore()
    const { userTemplatePipeline, companyTemplatePipeline, setUserTemplatePipeline, setCompanyTemplatePipeline } = useTemplatePipeline()
    const { tablesData, setSelectedFilter, masterDateRange, setMasterDateRange, typeDateFilter, isFullyLoaded, setFetchCounter, fetchCounter } = useDataTableStore()
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [typeDate, setTypeDate] = useState(''); //<PipelineSourceFilterDate>
    const [selectByDateFilter, setSelectByDateFilter] = useState<null | { typeDateFilter: string, startDate: Date, endDate: Date }>(null); //<PipelineSourceFilterDate>
    const [loading, setLoading] = useState<boolean>(true);
    const [user_id, setUser_id] = useState<string>(user.data.id);
    const [user_name, setUser_name] = useState<string>(user.data.name);
    const [scope, setScope] = useState<UserScope>(user.data.permission_pipeline_read === 'TEAM' ? UserScope.WholeTeam : defaultScope(user.data.permission_pipeline_read));
    const [showAbandonedModal, setShowAbandonedModal] = useState<boolean>(false);
    const [showAddModal, setShowAddModal] = useState<boolean>(false);
    const [showAddLogModal, setShowAddLogModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
    const [showDetailTermin, setShowDetailTermin] = useState<boolean>(false);
    const [showDetailProductModal, setShowDetailProductModal] = useState<boolean>(false);
    const [showActivityModal, setShowActivityModal] = useState<boolean>(false);
    const [currentUser, setCurrentUser] = useState<UserData | null>(null);
    const [showOtpModal, setShowOtpModal] = useState<boolean>(false);
    const [pipeline, setPipeline] = useState<Pipeline>();
    const token = useAccessToken()
    const { settings } = useSettingsStore()
    const [customFields, setCustomFields] = useState<CustomField>({})
    const [showAttachmentModal, setShowAttachmentModal] = useState<boolean>(false);
    const [key, setKey] = useState<string>('');
    const [url, setUrl] = useState<string | string[]>('');
    const { updatedData: updatedDataColumn, setUpdatedData: setUpdatedDataColumn, handleDragEnd: handleDragEndColumn, sensors: sensorsColumn } = useDragAndDropColumn();
    const { updatedData: updatedDataCompany, setUpdatedData: setUpdatedDataCompany, handleDragEnd: handleDragEndCompany, sensors: sensorsCompany, hasChanges: hasChangesCompany, initializeData: initializeDataCompany, cancelChanges: cancelChangesCompany } = useDragAndDropTemplate();
    const { updatedData: updatedDataPersonal, setUpdatedData: setUpdatedDataPersonal, handleDragEnd: handleDragEndPersonal, sensors: sensorsPersonal, hasChanges: hasChangesPersonal, initializeData: initializeDataPersonal, cancelChanges: cancelChangesPersonal } = useDragAndDropTemplate();
    const [selectAllColumn, setSelectAllColumn] = useState<boolean>(true);
    const navigate = useNavigate()
    const webView = localStorage.getItem("web-view") === "true" ? true : false
    const [displayMode, setDisplayMode] = useState<string>(settings.default_pipeline_view_mode);
    const [isMounted, setIsMounted] = useState(false);
    const actionRef = useRef<Menu>(null);
    const { isMobile } = useCheckIsMobile()
    const { currentProgressOver, setCurrentProgressOver, setAllowedContainerToDrop } = useDNDPipelineStore()
    const { setIsShowFormLogLead } = useGeneralStore()
    const [copyDataPipeline, setCopyDataPipeline] = useState<IPipeline | null>(null)
    const intl = useIntl()

    const predefinedRanges = usePredefinedRanges();
    const calendarLocale = useCalendarLocale();

    const optionsTypeDate = [
        { value: '1', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_CREATED" }) },
        { value: '2', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_STARTED" }) },
        { value: '3', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_ENDED" }) },
    ]

    const optionsTypeDateForCustomCompany = [
        ...Object.keys(customFields).filter((key) => customFields[key].type === 'dateTimeRange').map((key) => ({ value: key, label: customFields[key].name }))
    ]

    const resultMergeOptionsTypeDate = user.data.company_id === companyId.pratesis || user.data.company_id === companyId.looyalIT ? [...optionsTypeDate, ...optionsTypeDateForCustomCompany] : optionsTypeDate

    const handleClickAction = (event: React.MouseEvent<HTMLButtonElement>, row: Pipeline) => {
        setPipeline(row)
        actionRef.current?.toggle(event);
    }

    useEffect(() => {
        if (copyDataPipeline && Object.keys(copyDataPipeline).length > 0) {
            setShowAddModal(true)
        }
    }, [copyDataPipeline])

    const fetchCurrentUser = async () => {
        try {
            const response = await getUserByToken(token);
            setCurrentUser(response.data.data);
        } catch (error) {
            Swal.fire({
                icon: "warning",
                title: "Error",
                text: "Unable to fetch user data. Please try again.",
            });
        }
    };

    useEffect(() => {
        if (token) {
            fetchCurrentUser();
        }
    }, [token]);

    const handleAddLog = () => {
        if (pipeline?.has_pending_log) {
            setShowOtpModal(true);
        } else {
            setShowAddLogModal(true);
        }
    };

    let tableColumns: TableColumn<Pipeline>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            center: true,
            allowOverflow: true,
            width: '70px',
            id: 'fixedLeft',
            cell: (row) => {
                return (
                    <>
                        <Button
                            type="button"
                            icon="pi pi-ellipsis-v"
                            rounded
                            text
                            className="p-button-plain"
                            onClick={(event: any) => handleClickAction(event, row)}
                        />
                    </>
                )
            },
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }))?.omit
        },
        {
            name: '',
            id: 'labelsPipeline',
            style: { cursor: "pointer" },
            width: '50px',
            cell: (row) => {
                return (
                    <ComponentLabelsPipeline row={row} />
                )
            },
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED' }),
            id: 'dateCreated',
            style: { cursor: "pointer" },
            width: '120px',
            selector: row => row.date_created,
            cell: (row) => {
                return (
                    moment(row.date_created).format("DD MMM YYYY")
                )
            },
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME_TITLE' }, { title: settings.merchant_title }),
            id: 'merchantName',
            style: { cursor: "pointer", paddingTop: "10px", paddingBottom: "10px" },
            width: '250px',
            selector: row => row.merchant_name,
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME_TITLE' }, { title: settings.merchant_title }))?.omit,
            cell: (row) => {
                return (
                    <div className="d-flex align-items-center gap-3">
                        {(() => {
                            switch (row.hot_warm_cold_status) {
                                case 'hot':
                                    return (
                                        <>
                                            <div className="d-flex flex-column">
                                                {(Array.isArray(row?.paymentTermins) && row.paymentTermins.length > 0 && row.paymentTermins[0]?.nominal! > 0) && <span className="badge badge-light-dark" style={{ borderRadius: "100px", width: "fit-content" }}>{intl.formatMessage({ id: "FORM.LABEL.TERMIN" })}</span>}
                                                <span>{row.merchant_name}</span>
                                                {row.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{row.merchant_link.merchantName}</p>}
                                            </div>
                                            <span className="badge badge-light-danger ms-3">Hot</span>
                                        </>
                                    );
                                case 'warm':
                                    return (
                                        <>
                                            <div className="d-flex flex-column">
                                                {(Array.isArray(row?.paymentTermins) && row.paymentTermins.length > 0 && row.paymentTermins[0]?.nominal! > 0) && <span className="badge badge-light-dark" style={{ borderRadius: "100px", width: "fit-content" }}>{intl.formatMessage({ id: "FORM.LABEL.TERMIN" })}</span>}
                                                <span>{row.merchant_name}</span>
                                                {row.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{row.merchant_link.merchantName}</p>}
                                            </div>
                                            <span className="badge badge-light-warning ms-3">Warm</span>
                                        </>
                                    );
                                case 'cold':
                                    return (
                                        <>
                                            <div className="d-flex flex-column">
                                                {(Array.isArray(row?.paymentTermins) && row.paymentTermins.length > 0 && row.paymentTermins[0]?.nominal! > 0) && <span className="badge badge-light-dark" style={{ borderRadius: "100px", width: "fit-content" }}>{intl.formatMessage({ id: "FORM.LABEL.TERMIN" })}</span>}
                                                <span>{row.merchant_name}</span>
                                                {row.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{row.merchant_link.merchantName}</p>}
                                            </div>
                                            <span className="badge badge-light-primary ms-3">Cold</span>
                                        </>
                                    );
                                default:
                                    return (
                                        <>
                                            <div className="d-flex flex-column">
                                                {(Array.isArray(row?.paymentTermins) && row.paymentTermins.length > 0 && row.paymentTermins[0]?.nominal! > 0) && <span className="badge badge-light-dark" style={{ borderRadius: "100px", width: "fit-content" }}>{intl.formatMessage({ id: "FORM.LABEL.TERMIN" })}</span>}
                                                <span>{row.merchant_name}</span>
                                                {row.merchant_link && <p style={{ color: "#a1a5b7", marginBottom: '0px', fontStyle: 'italic' }}>{row.merchant_link.merchantName}</p>}
                                            </div>
                                        </>
                                    )
                            }
                        })()}
                    </div>
                );
            }

        },
        ...(user?.data.company_id === companyId.maspionSquare ? [
            {
                name: 'No Unit',
                id: 'noUnit',
                width: '200px',
                // selector: (row: Pipeline) => row.merchant_custom_fields['dea8766f-93ed-472a-92b8-7d94444609e0'],
                cell: (row: Pipeline) => row.merchant_custom_fields['dea8766f-93ed-472a-92b8-7d94444609e0'] ? row.merchant_custom_fields['dea8766f-93ed-472a-92b8-7d94444609e0'] : "-",
                sortable: false,
                allowOverflow: true,
                reorder: true,
                omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.INFORMATION' }))?.omit
            }
        ] : []),
        {
            name: user.data.company_id === companyId.elgisa ? "Opportunity" : intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOTES' }),
            id: 'note',
            style: { cursor: "pointer" },
            width: '250px',
            selector: row => row.note,
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOTES' }))?.omit,
            cell: (row) => {
                if (row.note) return <div dangerouslySetInnerHTML={{ __html: (row.note).replaceAll('\n', '<br/>') }}></div>
                else return "-"
            },
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }),
            id: 'ownerName',
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.owner_name?.toLowerCase(),
            sortable: true,
            cell: row => row.owner_name,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TOTAL_LOGS' }),
            id: 'totalLogs',
            style: { cursor: "pointer", justifyContent: 'right' },
            width: '110px',
            selector: row => row.lead_logs_count,
            sortable: true,
            reorder: true,
            cell(row) {
                return (
                    <span>{row.lead_logs_count && customNumberFormat(row.lead_logs_count)}</span>
                )
            },
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TOTAL_LOGS' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS' }),
            id: 'progressName',
            style: { cursor: "pointer", width: "auto" },
            // width: 'auto',
            grow: 3,
            width: '150px',
            center: true,
            selector: row => row.lead_progress_name,
            cell(row) {
                const progressName = row.lead_progress_name;
                const subProgressName = row.lead_subprogress_name;
                const progressColor = row.lead_progress_color;

                // Generate badge content
                const badgeContent = subProgressName
                    ? `${progressName} (${subProgressName})`
                    : progressName;

                // Determine the badge style based on progress color
                const badgeStyle = progressColor
                    ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
                    : { backgroundColor: "transparent", }; // Default when no color

                const progressBadge = (
                    <BadgeTooltip tooltipText={badgeContent} badgeClass={`my-2 mx-1 ${progressColor ? '' : 'badge-light-info'}`} style={badgeStyle}>
                        {badgeContent}
                    </BadgeTooltip>
                );

                // Return the badge component
                return (
                    <div className="d-flex justify-content-between w-100">
                        {progressBadge}
                        {row.has_pending_log && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id='toltip-progress'>
                                        {intl.formatMessage({ id: "FORM.LABEL.PENDING_LOG" })}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-warning fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            },
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHONE' }),
            id: 'merchantPhone',
            style: { cursor: "pointer" },
            width: '150px',
            allowOverflow: true,
            selector: row => Number(row.merchant_phone),
            cell(row) {
                return row.merchant_phone;
            },
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHONE' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.WHATSAPP' }),
            id: 'merchantIsWhatsapp',
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.merchant_is_whatsapp_phone,
            sortable: true,
            center: true,
            reorder: true,
            cell: row => {
                if (row.merchant_is_whatsapp_phone) return <img alt='Phone' style={{ padding: "15px" }} onClick={() => redirectWhatsappValid(row.merchant_id, row.merchant_phone)} className='h-50px cursor-pointer' src={toAbsoluteUrl('/media/assets/checked.png')} />
                else return <img alt='Phone' style={{ padding: "15px" }} onClick={() => redirectWhatsappNotValid(row.merchant_id, row.merchant_phone)} className='h-50px cursor-pointer' src={toAbsoluteUrl('/media/assets/remove.png')} />
            },
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.WHATSAPP' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.AGE' }),
            id: 'age',
            style: { cursor: "pointer" },
            width: '150px',
            allowOverflow: true,
            selector: row => getDateSummary(row.lead_age),
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.AGE' }))?.omit,
            sortFunction: (rowa: any, rowb: any) => {

                const numA = Number(rowa.lead_age);
                const numB = Number(rowb.lead_age);

                if (numA < numB) {
                    return -1;
                }
                if (numA > numB) {
                    return 1;
                }
                return 0;
            }

        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL' }) + " (" + selectMultiPipeline.currencyCode + ")",
            id: 'nominal',
            style: { cursor: "pointer", justifyContent: 'space-between' },
            width: '170px',

            selector: (row: any) => Number(row.nominal),
            cell: (row: any) => {
                return (
                    <>
                        <span>{getCurrencySymbol(selectMultiPipeline.currencyCode)}</span><span>{row.nominal && currencyFormatter(row.nominal, selectMultiPipeline.currencyIsRounded)}</span>
                    </>
                )
            },
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL' }) + " (" + selectMultiPipeline.currencyCode + ")")?.omit,
        },
        ...(user?.data.company_name === "Maspion Square" ? [
            {
                name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL_BEFORE_VAT' }) + " (" + selectMultiPipeline.currencyCode + ")",
                id: 'nominal_without_vat',
                style: { cursor: "pointer", justifyContent: 'space-between' },
                width: '170px',
                selector: (row: any) => Number(row.nominal_without_vat),
                cell: (row: any) => {
                    return (
                        <>
                            <span>{getCurrencySymbol(selectMultiPipeline.currencyCode)}</span><span>{row.nominal_without_vat && currencyFormatter(row.nominal_without_vat, selectMultiPipeline.currencyIsRounded)}</span>
                        </>
                    )
                },
                sortable: true,
                reorder: true,
                omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL_BEFORE_VAT' }) + " (" + selectMultiPipeline.currencyCode + ")")?.omit,
            }
        ] : []),

        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PRODUCT' }),
            id: 'products',
            style: { cursor: "pointer" },
            width: '250px',
            selector: row => row.leadProducts.map((data: ListProduct) => data.productName).join(', '),
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PRODUCT' }))?.omit,
            cell: row => {
                const leadProducts = row.leadProducts
                if (leadProducts.length > 0) {
                    return (
                        <ExpandableElement
                            content={
                                <>
                                    {leadProducts.map((product: ListProduct, index: number) => {
                                        return (
                                            <ul key={index} className='w-100' style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                                <li>
                                                    <span>
                                                        {product.productName} {product.unitName ? `(${product.unitName})` : '(PCS)'}
                                                    </span><br />
                                                    <span className='text-muted'>
                                                        {product.leadProductNotes && product.leadProductNotes !== '-' ? `*${product.leadProductNotes}` : ''}
                                                    </span>
                                                </li>
                                            </ul>
                                        )
                                    })}
                                </>
                            }
                            maxHeight={70} />
                    )
                } else {
                    return '-'
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SUM_PRODUCTS' }),
            id: 'sumProducts',
            style: { cursor: "pointer", justifyContent: 'center' },
            width: '150px',
            selector: row => Number(row.leadProducts.reduce((total, data) => total + Number(data.leadProductQty), 0)),
            cell: row => (
                <span>{customNumberFormat(row.leadProducts.reduce((total, data) => total + Number(data.leadProductQty), 0))}</span>
            ),
            center: true,
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SUM_PRODUCTS' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SOURCE' }),
            id: 'source',
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.lead_source_name,
            cell(row) {
                const leadSourceName = row.lead_source_name;
                let badgeClass = "badge-light-info"; // Default badge style

                switch (leadSourceName) {
                    case 'INBOUND':
                        badgeClass = "badge-light-primary";
                        break;
                    case 'OUTBOUND':
                        badgeClass = "badge-light-success";
                        break;
                    default:
                        break;
                }

                // Return the badge component wrapped in OverlayTrigger
                return (
                    <BadgeTooltip children={leadSourceName} tooltipText={leadSourceName} badgeClass={badgeClass} />
                );
            },
            sortable: true,
            reorder: true,
            center: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.SOURCE' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }),
            id: 'createdBy',
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.creator_name,
            sortable: true,
            allowOverflow: true,
            reorder: true,
            wrap: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_STARTED' }),
            id: 'dateStart',
            style: { cursor: "pointer" },
            width: '120px',
            selector: row => row.date_start,
            cell: (row) => {
                return (
                    moment(row.date_start).format("DD MMM YYYY HH:mm")
                )
            },
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_STARTED' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_ENDED' }),
            id: 'dateEnd',
            style: { cursor: "pointer" },
            width: '120px',
            selector: row => row.date_end ? row.date_end : "-",
            cell: (row) => {
                return (
                    row.date_end ? moment(row.date_end).format("DD MMM YYYY HH:mm") : "-"
                )
            },
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_ENDED' }))?.omit,
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_LAST_UPDATED' }),
            id: 'dateLastUpdate',
            style: { cursor: "pointer" },
            width: '180px',
            selector: row => row.date_last_update ? row.date_last_update : "-",
            cell: (row) => {
                return (
                    row.date_last_update ? moment(row.date_last_update).format("DD MMM YYYY HH:mm") : "-"
                )
            },
            sortable: true,
            allowOverflow: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_LAST_UPDATED' }))?.omit,
        },
        ...(user?.data.company_id === companyId.esb ? [
            {
                name: 'Company Code',
                id: 'companyCode',
                width: "200px",
                selector: (row: Pipeline) => row.merchant_company_code ? row.merchant_company_code : '-',
                sortable: true,
                allowOverflow: true,
                reorder: true,
                omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.INFORMATION' }))?.omit
            }
        ] : []),
        ...(user?.data.company_name === "Juragan Material" ? [
            {
                name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.INFORMATION' }),
                id: 'information',
                width: '200px',
                selector: (row: Pipeline) => row.from_excel,
                cell: (row: Pipeline) => row.from_excel ? intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DESC_INFORMATION' }) : "-",
                sortable: true,
                allowOverflow: true,
                reorder: true,
                omit: updatedDataColumn.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.INFORMATION' }))?.omit
            }
        ] : []),
        ...((user.data.company_id === companyId.looyalIT || user.data.company_id === companyId.yClinic) && SHOW_COLUMN_MR_CODE.includes(templatePipelineId as string) ? [
            {
                name: 'Mr-Code',
                id: 'mr_code',
                width: '200px',
                selector: (row: Pipeline) => row.mr_code,
                cell: (row: Pipeline) => row.mr_code ? row.mr_code : "-",
                sortable: true,
                allowOverflow: true,
                reorder: true,
                omit: updatedDataColumn.find(item => item.name === 'Mr-Code')?.omit
            }
        ] : []),
    ];

    if (user.data.company_id !== companyId.elgisa && user.data.company_id !== companyId.yClinic) {
        tableColumns = tableColumns.filter(column => column.id !== "note");
    }

    const tableColumnsWithCustomFields: TableColumn<Pipeline>[] = [
        ...tableColumns,
        ...Object.keys(customFields).map((key, index) => {
            const customField = customFields[key];
            let columns: TableColumn<Pipeline>[] = [];

            if (customField.type === 'invoice_reminder') {
                const fileColumn: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key + " (File)",
                    width: "150px",
                    name: customField.name + " (File)",
                    center: true,
                    sortable: true,
                    selector: (row: Pipeline) => row.custom_fields && row.custom_fields[key] ? JSON.parse(row.custom_fields[key] as string).invoice_url : '-',
                    sortFunction: (rowa: Pipeline, rowb: Pipeline) => {
                        const invoiceUrla: string | null = rowa.custom_fields && rowa.custom_fields[key] ? JSON.parse(rowa.custom_fields[key] as string).invoice_url : null;
                        const invoiceUrlb: string | null = rowb.custom_fields && rowb.custom_fields[key] ? JSON.parse(rowb.custom_fields[key] as string).invoice_url : null;

                        // Handle cases where one or both invoice_urls might be null
                        if (invoiceUrla && !invoiceUrlb) {
                            return 1; // rowa comes after rowb
                        }
                        if (!invoiceUrla && invoiceUrlb) {
                            return -1; // rowa comes before rowb
                        }

                        // If both invoice_urls exist, compare them
                        if (invoiceUrla && invoiceUrlb) {
                            if (invoiceUrla > invoiceUrlb) {
                                return 1;
                            }
                            if (invoiceUrla < invoiceUrlb) {
                                return -1;
                            }
                        }

                        return 0; // If they are equal or both are null
                    },

                    cell: (row: Pipeline) => {
                        const invoiceUrl = row.custom_fields && row.custom_fields[key] && JSON.parse(row.custom_fields[key] as string).invoice_url;
                        return invoiceUrl ? (
                            <a
                                href={invoiceUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-active-color-primary btn-bg-light btn-icon btn-sm ms-2"
                            >
                                <i className="float-end fa-file-invoice fas fs-3"></i>
                            </a>
                        ) : '-';
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name + " (File)")?.omit
                };
                columns.push(fileColumn);

                const tglExpiredColumn: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name + ` (${intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE' }, { title: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.EXPIRED' }) })})`,
                    selector: (row: Pipeline) => {
                        const dateDue = row.custom_fields && row.custom_fields[key] && JSON.parse(row.custom_fields[key] as string).date_due;
                        return dateDue ? moment(dateDue).format('DD MMM YYYY') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name + ` (${intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE' }, { title: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.EXPIRED' }) })})`)?.omit
                };
                columns.push(tglExpiredColumn);
            } else if (customField.type === 'date') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Pipeline) => {
                        const dateValue = row.custom_fields && row.custom_fields[key];
                        return dateValue ? moment(dateValue).format('DD MMM YYYY') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'image' || customField.type === 'images') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "70px",
                    name: customField.name,
                    center: true,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Pipeline) => {
                        const imageUrl = row.custom_fields && row.custom_fields[key];
                        return imageUrl ? (
                            <span role="button" onClick={() => {
                                setShowAttachmentModal(true);
                                setPipeline(row);
                                setKey(key);
                                setUrl(imageUrl as any);
                            }}>
                                <i className="fa-eye fas fs-2"></i>
                            </span>
                        ) : '-';
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit,
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        let imageUrlA = rowA.custom_fields?.[key];
                        let imageUrlB = rowB.custom_fields?.[key];

                        // Handle string or array cases
                        imageUrlA = Array.isArray(imageUrlA) ? imageUrlA.join(', ') : imageUrlA || '';
                        imageUrlB = Array.isArray(imageUrlB) ? imageUrlB.join(', ') : imageUrlB || '';

                        return imageUrlA.localeCompare(imageUrlB);
                    },
                };
                columns.push(column);
            } else if (customField.type === 'file' || customField.type === 'files' || customField.type === 'video' || customField.type === 'videos') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "70px",
                    name: customField.name,
                    center: true,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Pipeline) => {
                        const fileUrl = row.custom_fields && row.custom_fields[key];
                        if (typeof fileUrl === "string") {
                            return fileUrl ? (
                                <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-active-color-primary btn-bg-light btn-icon btn-sm ms-2"
                                >
                                    <i className="float-end fa-file-invoice fas fs-3"></i>
                                </a>
                            ) : '-';
                        } else {
                            return fileUrl ? (
                                <span role="button" onClick={() => {
                                    setShowAttachmentModal(true);
                                    setPipeline(row);
                                    setKey(key);
                                    setUrl(fileUrl as string[]);
                                }}>
                                    <i className="float-end fa-file-invoice fas fs-3"></i>
                                </span>
                            ) : '-';
                        }
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit,
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        let fileUrlA = rowA.custom_fields?.[key];
                        let fileUrlB = rowB.custom_fields?.[key];

                        // Handle both string and array cases
                        fileUrlA = Array.isArray(fileUrlA) ? fileUrlA.join(', ') : fileUrlA || '';
                        fileUrlB = Array.isArray(fileUrlB) ? fileUrlB.join(', ') : fileUrlB || '';

                        return fileUrlA.localeCompare(fileUrlB);
                    }
                };
                columns.push(column);
            } else if (customField.type === 'multiple' || customField.type === 'option' || customField.type === 'multipleOption' || customField.type === 'text' || customField.type === 'pipeline_invoice' || customField.type === 'phone') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        const fieldValue = row.custom_fields && (row.custom_fields[key] as string);
                        const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                            ? '-'
                            : fieldValue;

                        return displayValue || '-';
                    },
                    cell: (row: Pipeline) => {
                        const values = row.custom_fields && row.custom_fields[key] && row.custom_fields[key].toString();
                        if (customField.type === 'text') return values ? values.replaceAll(',', '') : '-';
                        else if (customField.type === 'option') {
                            return values ? (
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div>{values}</div>
                                </div>
                            ) : "-"
                        } else if (customField.type === 'multipleOption') {
                            return values ? (
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div>{values.split(',').join(', ')}</div>
                                </div>
                            ) : "-"
                        } else return values ? values.split(',').join(', ') : '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'serial') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    cell: (row: Pipeline) => {
                        const values = row.custom_fields && row.custom_fields[key];
                        return typeof values === 'string' ? values : (values as string[])?.length > 0 ? (values as string[]).join('') : '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'pipeline') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return (
                                <div className="d-flex flex-column">
                                    <span><b>{(values[0] as any).name}</b> / </span>
                                    <span>{(values[0] as any).nominal} / </span>
                                    <span>{moment((values[0] as any).dateCreated).format("DD MMM YYYY")}</span>
                                </div>
                            );
                        }
                        return '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'merchant') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.merchant_name).join(', ');
                        }
                        return '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        const valueA = (rowA as any)[`custom_fields.${key}`] ?? "";
                        const valueB = (rowB as any)[`custom_fields.${key}`] ?? "";

                        // Pastikan hanya membandingkan string
                        if (typeof valueA === 'string' && typeof valueB === 'string') {
                            return valueA.localeCompare(valueB);
                        }
                        return 0; // Tidak ada perbandingan jika bukan string
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'meeting') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status}`).join(', ');
                        }
                        return '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'user') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.name).join(', ');
                        }
                        return '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        const valueA = (rowA as any)[`custom_fields.${key}`] ?? "";
                        const valueB = (rowB as any)[`custom_fields.${key}`] ?? "";

                        // Pastikan hanya membandingkan string
                        if (typeof valueA === 'string' && typeof valueB === 'string') {
                            return valueA.localeCompare(valueB);
                        }
                        return 0; // Tidak ada perbandingan jika bukan string
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'link') {
                const column: TableColumn<Pipeline> = {
                    name: customField.name,
                    id: key,
                    grow: 2,
                    cell: (row: Pipeline) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return (
                                <a
                                    href={row.custom_fields[key] as string}
                                    rel="noreferrer"
                                    className="btn btn-active-light btn-outline btn-outline-default btn-sm text-gray-600"
                                    target="_blank"
                                >
                                    Lihat
                                    <i className="p-0 fa-external-link-alt fas fs-6 ms-2"></i>
                                </a>
                            );
                        } else {
                            return "-";
                        }
                    },
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        const linkA = Array.isArray(rowA.custom_fields?.[key])
                            ? rowA.custom_fields?.[key][0] // Ambil nilai pertama jika array
                            : rowA.custom_fields?.[key] || "";

                        const linkB = Array.isArray(rowB.custom_fields?.[key])
                            ? rowB.custom_fields?.[key][0]
                            : rowB.custom_fields?.[key] || "";

                        // Bandingkan hanya jika kedua nilai adalah string
                        if (typeof linkA === "string" && typeof linkB === "string") {
                            return linkA.localeCompare(linkB);
                        }
                        return 0;
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit

                }
                columns.push(column);
            } else if (customField.type === 'number') {
                const column: TableColumn<Pipeline> = {
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return customThousandSeparatorDot(row.custom_fields[key] as unknown as number) || ""
                        } else {
                            return '-'
                        }
                    },
                    cell: (row: Pipeline) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return customThousandSeparatorDot(row.custom_fields[key] as unknown as number) || ""
                        } else {
                            return '-'
                        }
                    },
                    reorder: true,
                    sortable: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                }
                columns.push(column);
            } else if (customField.type === 'dateTimeRange') {
                const column: TableColumn<Pipeline> = {
                    id: key,
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? (row.custom_fields[key] as string[]).map((item: any) => item).join(' - ') : '-'
                    },
                    width: "200px",
                    cell: (row: Pipeline) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return Array.isArray(row.custom_fields[key]) && (row.custom_fields[key] as string[]).map((item: any) => moment(item).format('DD MMM YYYY HH:mm')).join(' - ')
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                }
                columns.push(column);
            } else if (customField.type === 'time') {
                const column: TableColumn<Pipeline> = {
                    id: key,
                    name: customField.name,
                    width: '150px',
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? moment(row.custom_fields[key]).format('HH:mm') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                }
                columns.push(column);
            } else if (customField.type === 'email') {
                const column: TableColumn<Pipeline> = {
                    id: key,
                    width: '150px',
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-'
                    },
                    cell: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-'
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                }
                columns.push(column);
            } else if (customField.type === 'dateTime') {
                const column: TableColumn<Pipeline> = {
                    id: key,
                    width: '200px',
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Pipeline) => {
                        return row.custom_fields && row.custom_fields[key] ? moment(row.custom_fields[key]).format('DD MMM YYYY HH:mm') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                }
                columns.push(column);
            } else if (customField.type === 'product') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "150px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.product_name).join(', ');
                        }
                        return '-';
                    },
                    allowOverflow: true,
                    sortable: true,
                    sortFunction: (rowA: Pipeline, rowB: Pipeline) => {
                        const valueA = (rowA as any)[`custom_fields.${key}`] ?? "";
                        const valueB = (rowB as any)[`custom_fields.${key}`] ?? "";

                        // Pastikan hanya membandingkan string
                        if (typeof valueA === 'string' && typeof valueB === 'string') {
                            return valueA.localeCompare(valueB);
                        }
                        return 0; // Tidak ada perbandingan jika bukan string
                    },
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            } else if (customField.type === 'paragraph') {
                const column: TableColumn<Pipeline> = {
                    style: { cursor: "pointer" },
                    id: key,
                    width: "200px",
                    name: customField.name,
                    selector: (row: Pipeline) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Pipeline) => {
                        const values = row.custom_fields && row.custom_fields[key] && row.custom_fields[key].toString();
                        return values ? (
                            <ExpandableElement
                                content={
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                        {values}
                                    </div>
                                }
                                maxHeight={100}
                            />
                        ) : "-"
                    },
                    allowOverflow: true,
                    sortable: true,
                    reorder: true,
                    omit: updatedDataColumn.find(item => item.name === customField.name)?.omit
                };
                columns.push(column);
            }

            return columns;
        }).flat(),
    ];

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token,
            },
        });
        return response.data.data;
    };

    const { data: progresses = [], error: progressesError, isLoading: progressesLoading } = useSWR(`${API_URL}lead_progresses?onlyShowAllowedForCreateLeadLog=true&leadTemplateId=${templatePipelineId}`, fetcher);
    const { data: userTemplate = [], error: userTemplateError, isLoading: userTemplateLoading } = useSWR(templatePipelineId ? `${API_URL}user-view-templates?leadTemplateId=${templatePipelineId}` : null, fetcher)
    const { data: companyTemplate = [], error: companyTemplateError, isLoading: companyTemplateLoading } = useSWR(templatePipelineId ? `${API_URL}company-view-templates?leadTemplateId=${templatePipelineId}` : null, fetcher)
    const { data: labels = [], error: labelsError, isLoading: labelsLoading } = useSWR(`${API_URL}labels?usableBy[]=pipeline`, fetcher)

    useEffect(() => {
        const progressesID: string[] = progresses.map((progress: Progress) => progress.id)
        setAllowedContainerToDrop(progressesID)
    }, [progresses])

    // SORT COLUMN DATATABLE
    if (user.data.company_id === companyId.enterpriseSales || user.data.company_id === companyId.enterpriseService) {
        tableColumnsWithCustomFields.push({
            style: { cursor: "pointer" },
            width: "150px",
            name: 'Invoice',
            selector: (row: Pipeline) => {
                if (row.custom_fields[keyCustomfield.serial.enterpriseSales]) {
                    return (row.custom_fields[keyCustomfield.serial.enterpriseSales] as string[]).join('')
                } else if (row.custom_fields[keyCustomfield.serial.enterpriseService]) {
                    return (row.custom_fields[keyCustomfield.serial.enterpriseService] as string[]).join('')
                } else {
                    return "-"
                }
            },
            cell: (row: Pipeline) => {
                if (row.custom_fields[keyCustomfield.serial.enterpriseSales]) {
                    return (row.custom_fields[keyCustomfield.serial.enterpriseSales] as string[]).join('')
                } else if (row.custom_fields[keyCustomfield.serial.enterpriseService]) {
                    return (row.custom_fields[keyCustomfield.serial.enterpriseService] as string[]).join('')
                } else {
                    return "-"
                }
            },
            allowOverflow: true,
            sortable: true,
            reorder: true,
            omit: updatedDataColumn.find(item => item.name === 'Invoice')?.omit
        })

        const invoiceIndex = tableColumnsWithCustomFields.findIndex(col => col.name === 'Invoice');
        const merchantIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME_TITLE' }, { title: settings.merchant_title }));
        sortColumnDatatable(tableColumnsWithCustomFields, invoiceIndex, merchantIndex + 1);
    }

    if (user.data.company_name === "Heiszco") {
        const productsIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PRODUCT" }));
        const subSectorIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string)?.toLowerCase() === "sub sector/nama project");
        const picIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PIC" }));
        sortColumnDatatable(tableColumnsWithCustomFields, productsIndex, picIndex + 1);
        sortColumnDatatable(tableColumnsWithCustomFields, subSectorIndex, picIndex + 2);
    }

    if (user.data.company_id === companyId.esb) {
        const companyCodeIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string)?.toLowerCase() === "company code");
        const nameIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME_TITLE' }, { title: settings.merchant_title }));
        companyCodeIndex !== -1 && sortColumnDatatable(tableColumnsWithCustomFields, companyCodeIndex, nameIndex);
    }

    const updateWhatsappValid = async (id: string, phone: string, res: boolean) => {
        try {
            const response = await updateWhatsapp(id, res, token)
            if (response.data.success) {
                if (res) {
                    if (user.data.is_superadmin) {
                        window.open(`https://api.whatsapp.com/send?phone=${phone.replace("+", "")}`)
                    }
                    // else {
                    //     navigate('/chat')
                    //     setPhoneNumber(phone.replace("+", ""))
                    // }
                }
            }
        } catch (error) {

        }
    }

    const redirectWhatsappValid = async (id: string, phone: string) => {
        try {
            const response = await checkWhatsapp(phone.replace("+", ""))
            if (!response.data.result.exists) {
                updateWhatsappValid(id, phone, response.data.result.exists)
            } else {
                if (user.data.is_superadmin) {
                    window.open(`https://api.whatsapp.com/send?phone=${phone.replace("+", "")}`)
                }
                // else {
                //     navigate('/chat')
                //     setPhoneNumber(phone.replace("+", ""))
                //     getChatMessages(phone.replace("+", ""), '')
                // }
            }
        } catch (error) {

        }
    }

    const redirectWhatsappNotValid = async (id: string, phone: string) => {
        try {
            const response = await checkWhatsapp(phone.replace("+", ""))
            if (response.data.result.exists) {
                updateWhatsappValid(id, phone, response.data.result.exists)
            } else {
                Swal.fire({
                    icon: "error",
                    title: `${intl.formatMessage({ id: "FORM.VALIDATION.INVALID_NUMBER" })}.`,
                    heightAuto: false,
                })
            }
        } catch (error) {

        }
    }

    const onRowClicked = (row: Pipeline) => {
        setPipeline(row)
        setShowDetailModal(true);
    };

    const sortDataById = (data: TableColumn<Pipeline>[], sort: TableColumn<Pipeline>[]) => {
        const sortOrder = sort.reduce((acc: Record<string, number>, item: any, index: number) => {
            acc[item.id] = index;
            return acc;
        }, {});

        return data.sort((a: any, b: any) => sortOrder[a.id] - sortOrder[b.id]);
    };

    const handleResetFilter = () => {
        if (masterDateRange.pipeline?.startDate && masterDateRange.pipeline?.endDate) {
            setMasterDateRange({
                pipeline: null,
                merchant: null
            })
            setStartDate(getStartDate(user, companyId, selectMultiPipeline!))
            setEndDate(getEndDate(user, companyId, selectMultiPipeline!))
            setTypeDate(getTypeDate(selectMultiPipeline!))
            setFetchCounter(fetchCounter + 1)
        }
        setSelectedFilter('pipelines', 'leadProducts', [])
        if (companyId.sinertek === user.data.company_id) setSelectedFilter('pipelines', 'lead_progress_progress_type', [])
        else setSelectedFilter('pipelines', 'lead_progress_progress_type', ['ONGOING', 'SUCCESS'])
        setSelectedFilter('pipelines', 'lead_progress_name', [])
        setSelectedFilter('pipelines', 'owner_name', [])
        setSelectedFilter('pipelines', 'labels', [])
        setSelectedFilter('pipelines', 'leadProductLabels', [])
        setSelectedFilter('pipelines', 'lead_source_name', [])
        setSelectedFilter('pipelines', 'creator_name', [])
        setSelectedFilter('pipelines', 'unitNames', [])

        sortDataById(updatedDataColumn, tableColumnsWithCustomFields)
        setUpdatedDataColumn(updatedDataColumn.map((data: TableColumn<Pipeline>) => ({ ...data, omit: false })));
        setSelectAllColumn(true)
        setUserTemplatePipeline(
            userTemplatePipeline.map((data: TemplatePipelineProps) => ({
                ...data,
                content: {
                    ...data.content,
                    use: false,
                }
            }))
        );
        setCompanyTemplatePipeline(
            companyTemplatePipeline.map((data: TemplatePipelineProps) => ({
                ...data,
                content: {
                    ...data.content,
                    use: false,
                }
            }))
        );

    }

    const convertOldData = (oldData: any) => {
        const contentParsed = JSON.parse(oldData.content);
        const hide = contentParsed.column
            .filter((col: any) => col.omit) // Filter column yang di-omit
            .map((col: any) => {
                const matchedColumn = tableColumnsWithCustomFields.find((item) => item.name === col.name);
                return matchedColumn ? matchedColumn.id : null; // Mengambil id jika ditemukan
            })
            .filter((id: string | null): id is string => id !== null);
        const sort = tableColumnsWithCustomFields.map((col: any) => col.id);

        const newContent = {
            hide: hide,
            sort: sort,
            use: false,
            filter: contentParsed.filter
        };

        return {
            ...oldData,
            content: newContent
        };
    };

    useEffect(() => {
        if (!userTemplateLoading) {
            var data = userTemplate.map((template: any) => {
                let parsedContent;

                try {
                    parsedContent = JSON.parse(template.content);
                } catch (e) {
                    return template;
                }

                if (parsedContent.column) {
                    return convertOldData(template);
                } else {
                    return {
                        ...template,
                        content: parsedContent
                    };
                }
            });

            setUserTemplatePipeline(data);
        }
    }, [userTemplate]);

    useEffect(() => {
        if (!companyTemplateLoading) {
            var data = companyTemplate.map((template: any) => {
                let parsedContent;

                try {
                    parsedContent = JSON.parse(template.content);
                } catch (e) {
                    return template;
                }

                if (parsedContent.column) {
                    return convertOldData(template);
                } else {
                    return {
                        ...template,
                        content: parsedContent
                    };
                }
            });

            setCompanyTemplatePipeline(data);
        }
    }, [companyTemplate]);

    useEffect(() => {
        setUpdatedDataColumn(tableColumnsWithCustomFields);
    }, [customFields])

    useEffect(() => {
        setUpdatedDataCompany(companyTemplatePipeline)
    }, [companyTemplatePipeline])

    useEffect(() => {
        setUpdatedDataPersonal(userTemplatePipeline)
    }, [userTemplatePipeline])

    let actions: ReactNode[] = []
    // let searchComponent: ReactNode = <InputSearch tableKey={"pipelines"} tableColumns={tableColumns} />
    let actionsModeBoard: ReactNode[] = []
    if (user.data.is_allowed_export_excel && !webView) {
        actions.push(<BtnActionDropdownExportExcelPipeline columns={updatedDataColumn} dateRange={[startDate ?? new Date(), endDate ?? new Date()]} />)
        actionsModeBoard.push(<BtnActionDropdownExportExcelPipeline columns={updatedDataColumn} dateRange={[startDate ?? new Date(), endDate ?? new Date()]} />)
    }

    if (user.data.permission_pipeline_create !== 'NONE' && !merchantId) {
        if (settings.feature_import_excel_pipeline) {
            if (user?.data.company_id === companyId.juraganMaterial) {
                if (user?.data.role_id === roleId.juraganMaterial.superadmin || user?.data.role_id === roleId.juraganMaterial.salesHead) {
                    actions.push(
                        <DataTableImport source={"template-pipeline"} masterLabels={labels} />,
                    )
                }
            } else {
                actions.push(
                    <DataTableImport source={"template-pipeline"} masterLabels={labels} />,
                )
            }
        }

        actions.push(<BtnActionDropdownPipeline setShowAddPipeline={setShowAddModal} setShowFormLogLead={setIsShowFormLogLead} />);
        actionsModeBoard.push(<BtnActionDropdownPipeline setShowAddPipeline={setShowAddModal} setShowFormLogLead={setIsShowFormLogLead} />);
    }

    actions.push(<FilterPipeline
        propsData={{
            updatedData: {
                manageColumns: updatedDataColumn,
                updatedDataCompany: updatedDataCompany,
                updatedDataPersonal: updatedDataPersonal
            },
            setUpdatedData: {
                setManageColumns: setUpdatedDataColumn,
                setUpdatedDataCompany: setUpdatedDataCompany,
                setUpdatedDataPersonal: setUpdatedDataPersonal
            },
            handleDragEnd: {
                handleDragEndColumn: handleDragEndColumn,
                handleDragEndCompany: handleDragEndCompany,
                handleDragEndPersonal: handleDragEndPersonal
            },
            cancelChanges: {
                cancelChangesCompany: cancelChangesCompany,
                cancelChangesPersonal: cancelChangesPersonal
            },
            sensors: {
                sensorsColumn: sensorsColumn,
                sensorsCompany: sensorsCompany,
                sensorsPersonal: sensorsPersonal
            },
            hasChanges: {
                hasChangesCompany: hasChangesCompany,
                hasChangesPersonal: hasChangesPersonal
            },
            initializeData: {
                initializeDataCompany: () => initializeDataCompany(updatedDataCompany),
                initializeDataPersonal: () => initializeDataPersonal(updatedDataPersonal)
            }
        }}
        merchantId={merchantId!}
        handleResetFilter={handleResetFilter} selectAllColumn={selectAllColumn} setSelectAllColumn={setSelectAllColumn} />);

    useModalEffect({
        showModal: showAbandonedModal,
        setShowModal: setShowAbandonedModal,
        modalId: 'abandoned-pipeline-modal'
    })

    useModalEffect({
        showModal: showAddModal,
        setShowModal: setShowAddModal,
        modalId: 'add-pipeline-modal'
    })

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: `update-pipeline-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showAttachmentModal,
        setShowModal: setShowAttachmentModal,
        modalId: `attachments-custom-field-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showDeleteModal,
        setShowModal: setShowDeleteModal,
        modalId: `delete-pipeline-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showDetailProductModal,
        setShowModal: setShowDetailProductModal,
        modalId: `detail-product-pipeline-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showActivityModal,
        setShowModal: setShowActivityModal,
        modalId: `activity-pipeline-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showDetailModal,
        setShowModal: setShowDetailModal,
        modalId: `detail-pipeline-modal`
    })

    useModalEffect({
        showModal: showDetailTermin,
        setShowModal: setShowDetailTermin,
        modalId: `detail-termin-pipeline-modal-${pipeline?.id}`
    })

    useModalEffect({
        showModal: showAddLogModal,
        setShowModal: setShowAddLogModal,
        modalId: `tambah-log-modal`
    })

    useClearModalBackdropElement({ showModal: showAddModal })
    useClearModalBackdropElement({ showModal: showUpdateModal })

    useEffect(() => {
        setDisplayMode(settings.default_pipeline_view_mode)
    }, [templatePipelineId, scope, startDate, endDate])

    const { filterText, handleSearch } = useSearch("pipelines", tableColumnsWithCustomFields, "asc");

    const searchComponent = () => {
        return (
            <>
                <span className="position-absolute ms-6 mt-3 svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                    </svg>
                </span>
                <input
                    type="search"
                    data-kt-lists-table-filter="search"
                    className={`${displayMode === "table" ? "form-control-solid skeleton mt-3" : "border-body bg-body"} form-control w-210px ps-15`}
                    placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                    id="inputSearch"
                    value={filterText["pipelines"]}
                    onChange={e => { handleSearch(e.target.value) }}
                    onInput={(e) => handleCaps(e)}
                />
            </>
        )
    }

    const getFormatDate = () => {
        if (resultMergeOptionsTypeDate.map((item) => item.value).includes(optionsTypeDateForCustomCompany?.find(option => option.value === typeDate)?.value ?? '')) {
            return "dd MMM yyyy HH:mm"
        } else {
            return "dd MMM yyyy"
        }
    }

    useEffect(() => {
        if (isMounted) {
            if ((startDate && endDate && typeDate) || (masterDateRange.pipeline?.startDate && masterDateRange.pipeline?.endDate)) {
                setSelectByDateFilter({
                    typeDateFilter: masterDateRange.pipeline ? typeDateFilter : typeDate,
                    // startDate: startDate ?? user.data.company_id === companyId.hom ? subDays(today, 1) : user.data.company_id === companyId.happyPlay ? startOfMonth(today) : startOfYear(today),
                    // endDate: endDate ?? user.data.company_id === companyId.tkd ? endOfYear(today) : today,
                    startDate: (masterDateRange.pipeline?.startDate as Date) ?? startDate,
                    endDate: (masterDateRange.pipeline?.endDate as Date) ?? endDate,
                })
                // mutate(`${API_URL}v2/leads`);
                setFetchCounter(fetchCounter + 1)
            }
            return
        }
    }, [startDate, endDate, typeDate, masterDateRange.pipeline?.startDate, masterDateRange.pipeline?.endDate, isMounted]);

    useEffect(() => {
        if (templatePipelineId && multiPipelines.length > 0) {
            const data = multiPipelines.find(item => item.id === templatePipelineId)
            setCustomFields(data?.customFields!);
            mutate(`${API_URL}user-view-templates`);
            mutate(`${API_URL}company-view-templates`);
            mutate(`${API_URL}abandoned-leads?leadAge=5`);
            setSelectMultiPipeline(data!)
            setStartDate(getStartDate(user, companyId, data!))
            setEndDate(getEndDate(user, companyId, data!))
            setTypeDate(getTypeDate(data!))
            setIsMounted(true);
        }

    }, [multiPipelines, templatePipelineId, prevRoute])

    return (
        <>
            {
                tablesData.pipelinesAbandoned && tablesData.pipelinesAbandoned.length > 0 &&
                <div className="alert alert-danger">
                    <div className="d-flex align-items-center">
                        <KTSVG path="/media/icons/duotune/general/gen044.svg" className='me-2 svg-icon-2 svg-icon-danger' />
                        <span>{intl.formatMessage({ id: 'WARNING.PIPELINE.INACTIVE_PIPELINE.NEED_UPDATE' }, { title: settings.pipeline_title, title2: settings.pipeline_title })}
                            <b className="cursor-pointer" onClick={() => setShowAbandonedModal(true)}> <u>{intl.formatMessage({ id: 'WARNING.PIPELINE.INACTIVE_PIPELINE.VIEW_LIST' }, { title: settings.pipeline_title })}</u></b></span>
                    </div>
                </div>
            }

            <div className="row justify-content-between mb-3">
                {
                    !merchantId &&
                    <>
                        <div className="col-lg-4 col-sm-3 col-xl-5" style={{ alignSelf: "center" }}>
                            <ol className="text-muted breadcrumb fs-6 fw-bold">
                                <li className="text-muted breadcrumb-item">{settings.pipeline_title}</li>
                                <li className="text-dark breadcrumb-item">{selectMultiPipeline.name}</li>
                            </ol>
                        </div>

                        <div className="col-lg-8 col-sm-9 col-xl-7">
                            {
                                startDate && endDate && typeDate &&
                                <div className="d-flex float-end px-3">
                                    <Select
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                border: "none", // Menghilangkan simbol garis
                                                backgroundColor: "none",
                                                maxWidth: "200px"
                                            }),
                                            option: (baseStyles, { isSelected, isFocused }) => ({
                                                ...baseStyles,
                                                backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                cursor: 'pointer'
                                            }),
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary: 'none',
                                            },
                                        })}
                                        onChange={(data: any) => { setTypeDate(data.value) }}
                                        value={resultMergeOptionsTypeDate.find(option => option.value === typeDate)}
                                        className='react-select-styled z-index-3'
                                        classNamePrefix='react-select'
                                        options={resultMergeOptionsTypeDate}
                                        placeholder='Select an option'
                                        isSearchable={false}
                                    />


                                    <DateRangePicker
                                        style={{ width: "250px" }}
                                        cleanable={false}
                                        character=" - "
                                        format={getFormatDate()}
                                        locale={calendarLocale}
                                        value={[startDate, endDate]}
                                        ranges={predefinedRanges}
                                        placement="bottomEnd"
                                        onChange={(value) => {
                                            if (value && value.length === 2) {
                                                setStartDate(value[0]);
                                                setEndDate(value[1]);
                                            }
                                        }}
                                        showOneCalendar={isMobile}
                                        disabled={loading}
                                        isoWeek={true}
                                        editable={false}
                                    />

                                    {
                                        isFullyLoaded ?
                                            <div onClick={() => {
                                                mutate(`${API_URL}v2/leads`)
                                                setFetchCounter(fetchCounter + 1)
                                            }} className="btn btn-light btn-sm ms-2">
                                                <i className="p-0 fa-sync-alt fas"></i>
                                            </div> :
                                            <div className="ms-2 my-auto spinner-border spinner-border-sm" role="status">
                                            </div>
                                    }
                                </div>
                            }
                        </div>
                    </>
                }
            </div>

            <div className={`d-flex ${(user.data.permission_pipeline_read !== 'OWNED' && user.data.permission_pipeline_read !== 'NONE') && !merchantId ? 'justify-content-between' : 'justify-content-end'}`}>
                {
                    (user.data.permission_pipeline_read !== 'OWNED' && user.data.permission_pipeline_read !== 'NONE') && !merchantId &&
                    <UserScopeModal
                        user_id={user_id}
                        setUser_id={setUser_id}
                        user_name={user_name}
                        setUser_name={setUser_name}
                        scope={scope}
                        setScope={setScope}
                        permission={user.data.permission_pipeline_read}
                        apiURL="v2/leads"
                    />
                }

                <div className="d-flex align-items-center">
                    {
                        merchantId &&
                        <Select
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: "0.475rem",
                                    width: "fit-content",
                                    minWidth: "150px",
                                    boxShadow: 'none',
                                }),
                                option: (baseStyles, { isSelected, isFocused }) => ({
                                    ...baseStyles,
                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                    cursor: 'pointer',
                                }),
                                indicatorSeparator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    display: 'none',
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "fit-content",
                                    minWidth: "150px",
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "fit-content",
                                    minWidth: "150px",
                                }),
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: 'none',
                                },
                            })}
                            onChange={(data: any) => {
                                navigate('/merchants/' + templateMerchantId + "/" + merchantId + '/pipelines/' + data.value)
                            }}
                            closeMenuOnSelect={true}
                            placeholder={`Database ${settings.pipeline_title}`}
                            options={multiPipelines}
                            value={multiPipelines.find(option => option.value === templatePipelineId)}
                            className="mb-2 me-3 react-select-styled z-index-3"
                        />
                    }

                    <ul className="nav nav-pills align-items-center mb-2" style={{ flexWrap: "unset" }}>
                        <li className="nav-item m-0" onClick={() => { setDisplayMode("table"); }}>
                            <a className={`btn btn-sm btn-icon btn-white me-3 ${displayMode === "table" ? "btn-primary" : "btn-active-light-primary"}`} data-bs-toggle="tab" href="#tab_table_pipelines" >
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black"></path>
                                        <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="black"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li className="nav-item m-0" onClick={() => { setDisplayMode("kanban"); }}>
                            <a className={`btn btn-sm btn-icon btn-white ${displayMode === "kanban" ? "btn-primary me-5" : "btn-active-light-primary"}`} data-bs-toggle="tab" href="#tab_board_pipelines" >
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="5" y="5" width="5" height="5" rx="1" fill="#000000"></rect>
                                            <rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3"></rect>
                                            <rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3"></rect>
                                            <rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3"></rect>
                                        </g>
                                    </svg>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {
                displayMode === "kanban" &&
                <div className="mb-3" style={{ display: "flex", justifyContent: "space-between", alignItems: "stretch", flexWrap: "wrap" }}>
                    <div>
                        {searchComponent()}
                    </div>
                    <div className="d-flex card-toolbar align-self-center">
                        {
                            actionsModeBoard && actionsModeBoard.map((action, index) => (
                                <div key={index} className="ms-5 ms-md-3">
                                    {action}
                                </div>
                            ))
                        }
                    </div>
                </div>
            }

            {
                displayMode === 'table' ? (
                    <MasterDataTable
                        tableKey="pipelines"
                        tableColumns={updatedDataColumn}
                        actions={actions}
                        apiURL={`v2/leads`}
                        dateStart={moment(startDate).format('YYYY-MM-DD')}
                        dateEnd={moment(endDate).format('YYYY-MM-DD')}
                        dateStartFilter={masterDateRange.pipeline?.startDate ? moment(masterDateRange.pipeline?.startDate).format('YYYY-MM-DD') : undefined}
                        dateEndFilter={masterDateRange.pipeline?.endDate ? moment(masterDateRange.pipeline?.endDate).format('YYYY-MM-DD') : undefined}
                        customParams={masterDateRange.pipeline ? typeDateFilter : typeDate}
                        user_id={user_id}
                        merchantId={merchantId}
                        scope={scope}
                        setLoading={setLoading}
                        autoReload={false}
                        onRowClicked={onRowClicked}
                        searchComponent={searchComponent}
                        optionsTypeDateForCustomCompany={optionsTypeDateForCustomCompany}
                    />
                ) : (
                    <MasterKanban
                        tableKey="pipelines"
                        apiURL={`v2/leads`}
                        dateStart={moment(startDate).format('YYYY-MM-DD')}
                        dateEnd={moment(endDate).format('YYYY-MM-DD')}
                        dateStartFilter={masterDateRange.pipeline?.startDate ? moment(masterDateRange.pipeline?.startDate).format('YYYY-MM-DD') : undefined}
                        dateEndFilter={masterDateRange.pipeline?.endDate ? moment(masterDateRange.pipeline?.endDate).format('YYYY-MM-DD') : undefined}
                        customParams={masterDateRange.pipeline ? typeDateFilter : typeDate}
                        user_id={user_id}
                        merchantId={merchantId}
                        scope={scope}
                        setLoading={setLoading}
                        autoReload={false}
                        customState={
                            {
                                setShowUpdateModal: setShowUpdateModal,
                                setShowDeleteModal: setShowDeleteModal,
                                setShowAddLogModal: setShowAddLogModal,
                                setShowDetailModal: setShowDetailModal,
                                setShowDetailProductModal: setShowDetailProductModal,
                                setPipeline: setPipeline,
                            }
                        }
                    />
                )
            }

            <Menu
                popup
                ref={actionRef}
                model={[
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.COPY' }),
                        icon: 'pi pi-copy',
                        command: () => {
                            if (pipeline) {
                                const dataPipeline: IPipeline = {
                                    pic: pipeline?.owner_id,
                                    source: pipeline?.lead_source_id,
                                    startDate: pipeline?.date_start,
                                    labels: pipeline?.labels.map((label: Label) => label.id),
                                    merchant: pipeline?.merchant_id,
                                    note: pipeline?.note,
                                    listProducts: pipeline?.leadProducts,
                                    customFields: pipeline?.custom_fields
                                }
                                setCopyDataPipeline(dataPipeline)
                            }
                        },
                        visible: true
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.UPDATE' }),
                        icon: 'pi pi-pencil',
                        command: () => {
                            setShowUpdateModal(true);
                            setCopyDataPipeline(null)
                        },
                        visible: isActionUpdatePipeline(user, pipeline!, merchantId!)
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.DELETE' }),
                        icon: 'pi pi-trash',
                        command: () => {
                            setShowDeleteModal(true);
                            setCopyDataPipeline(null)
                        },
                        visible: isActionDeletePipeline(user, pipeline!, merchantId!)
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.LOGS' }),
                        icon: 'pi pi-eye',
                        command: () => {
                            window.open(`/pipelines/${templatePipelineId}/log/${pipeline?.id}`, '_blank');
                            setCopyDataPipeline(null)
                        },
                        visible: isActionLogPipeline(user)
                    },
                    {
                        label: pipeline?.has_pending_log
                            ? `${intl.formatMessage({ id: "FORM.LABEL.APPROVAL" })}`
                            : intl.formatMessage({ id: 'FORM.ACTION.ADD_LOG' }),
                        icon: 'pi pi-plus-circle',
                        command: () => {
                            handleAddLog();
                            setCopyDataPipeline(null)
                        },
                        visible: isActionAddLogPipeline(user, pipeline!, merchantId!, selectMultiPipeline, companyId)
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.PRODUCTS_DETAIL' }),
                        icon: 'pi pi-info-circle',
                        command: () => {
                            setShowDetailProductModal(true);
                            setCopyDataPipeline(null)
                        },
                        visible: isActionDetailProductPipeline(merchantId!)
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.ACTIVITIES' }),
                        icon: 'pi pi-eye',
                        command: () => {
                            setShowActivityModal(true);
                            setCopyDataPipeline(null)
                        },
                        visible: isActionActivitiyPipeline(user, companyId, roleId, merchantId!)
                    },
                    {
                        label: intl.formatMessage({ id: 'FORM.ACTION.DETAIL_TERMIN' }),
                        icon: 'pi pi-eye',
                        command: () => {
                            setShowDetailTermin(true);
                            setCopyDataPipeline(null)
                        },
                        visible: isActionDetailTerminPipeline(pipeline!)
                    },
                ].filter(Boolean)}
            />

            {
                showAddModal && <AddPipeline manageColumns={updatedDataColumn} setManageColumns={setUpdatedDataColumn} setScope={setScope} handleResetFilter={handleResetFilter} dateFilter={selectByDateFilter ? selectByDateFilter : undefined} copyDataPipeline={copyDataPipeline as IPipeline} setCopyDataPipeline={setCopyDataPipeline} />
            }
            {
                showDetailModal && <DetailPipeline data={pipeline!} />
            }
            {
                showOtpModal && pipeline?.id && currentUser && <OTPModal leadId={pipeline?.id} leadProgressId={tablesData.pipelines.find((item: any) => item.id === pipeline?.id)?.lead_progress_id} leadTemplateId={pipeline.lead_template_id} token={token} isOpen={showOtpModal} toggleModal={() => {setShowOtpModal(false)
                     document.body.style.overflow = "auto";
                }} currentUser={currentUser} />
            }
            {
                showUpdateModal && <UpdatePipeline pipeline={pipeline!} dateFilter={selectByDateFilter ? selectByDateFilter : undefined} />
            }
            {
                showDeleteModal && <DeletePipeline pipeline={pipeline!} />
            }
            {
                showAddLogModal && <AddLog lead={pipeline!} showModal={showAddLogModal} setShowModal={setShowAddLogModal} showAddLogButton progress={currentProgressOver} setProgress={setCurrentProgressOver} progresses={progresses} progressesLoading={progressesLoading} dateFilter={selectByDateFilter ? selectByDateFilter : undefined} />
            }
            {
                showAttachmentModal && <ModalAttachmentCustomField id={pipeline!.id} title={customFields[key].name!} url={url} />
            }
            {
                showDetailProductModal && <DetailProductPipeline pipeline={pipeline!} />
            }
            {
                showActivityModal && <ActivityPipeline pipeline={pipeline!} startDate={moment(startDate).format('YYYY-MM-DD')} endDate={moment(endDate).format('YYYY-MM-DD')} />
            }
            {
                settings.pipeline_abandoned_lock && <AbandonedPipeline showAbandonedModal={showAbandonedModal} setShowAbandonedModal={setShowAbandonedModal} pipeline_data={pipeline!} />
            }
            {
                showDetailTermin && <DetailTerminPipeline pipeline={pipeline!} isModal={true} />
            }

        </>
    )
}

export { MasterPipelinesContent }